import React from "react";
import { FiEdit, FiPlus, FiTrash2 } from "react-icons/fi";
import "./BankInfoTab.scss"; // Import your custom styles
import { useTranslation } from "react-i18next";

const BankInfoTab = ({ bank, isSelected, onEdit, onDelete, onAdd }) => {
  const { t } = useTranslation();

  if (!bank) {
    // Add new bank card
    return (
      <div
        className="card mb-4 shadow-sm d-flex align-items-center justify-content-center"
        style={{
          border: "2px dashed #0d6efd",
          cursor: "pointer",
          height: "160px",
          minWidth: "250px",
          transition: "transform 0.3s ease",
          color: "#0d6efd",
          fontSize: "2rem",
          fontWeight: "bold",
        }}
        onClick={onAdd}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}>
        <FiPlus />
        <span style={{ marginLeft: "8px", fontSize: "1.2rem" }}>
          {t("profile.addBank")}
        </span>
      </div>
    );
  }

  return (
    <div
      className={`card mb-4 shadow-sm position-relative overflow-hidden ${
        isSelected ? "border-primary" : "border-light"
      }`}
      style={{
        borderWidth: "2px",
        transition: "transform 0.3s ease",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}>
      {/* Overlay for selected bank */}
      {isSelected && (
        <div
          className="selected-overlay d-flex align-items-center justify-content-center"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(13 88 255 / 17%)",
            color: "#0d6efd",
            fontWeight: "bold",
            fontSize: "1.2rem",
            zIndex: 5,
            pointerEvents: "none",
            transition: "opacity 0.3s ease",
          }}>
          {t("profile.selected")}
        </div>
      )}

      {/* Edit/Delete buttons */}
      <div
        className="position-absolute top-0 end-0 p-2 d-flex gap-2"
        style={{ zIndex: 10 }}
        onClick={(e) => e.stopPropagation()}>
        <FiEdit
          className="text-primary"
          style={{ cursor: "pointer" }}
          onClick={() => onEdit(bank)}
        />
        <FiTrash2
          className="text-danger"
          style={{ cursor: "pointer" }}
          onClick={() => onDelete(bank)}
        />
      </div>

      <div className="card-body" style={{ position: "relative", zIndex: 1 }}>
        <div className="row">
          <div className="col-sm-6 mb-2">
            <small className="text-muted">{t("profile.bankName")}</small>
            <p className="text-dark mb-0">
              {bank?.name || t("profile.notProvided")}
            </p>
          </div>
          <div className="col-sm-6 mb-2">
            <small className="text-muted">{t("profile.iban")}</small>
            <p className="text-dark mb-0">
              {bank?.iban || t("profile.notProvided")}
            </p>
          </div>
          <div className="col-sm-6 mb-2">
            <small className="text-muted">{t("profile.bic")}</small>
            <p className="text-dark mb-0">
              {bank?.bic || t("profile.notProvided")}
            </p>
          </div>
          <div className="col-sm-6 mb-2">
            <small className="text-muted">{t("profile.rib")}</small>
            <p className="text-dark mb-0">
              {bank?.rib || t("profile.notProvided")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankInfoTab;
